import type { FeatureCategories } from 'src/modules/designStudio/constants';
import type { MenuItemType } from 'src/modules/designStudio/constants/hardCodedData/textureData';
import type { WindowItemType } from 'src/modules/designStudio/constants/hardCodedData/windowParametricData';
import type { DesignStudioColor } from 'src/shared/graphql/generated';
import type { ButtonPressed } from 'src/shared/telemetry';

export interface MacheteData {
  geometry: object;
  metadata: object;
}
export type Texture = {
  thumbnail: {
    url: string;
  };
  diffuse_map?: {
    url: string;
  };
};
export interface ProductEntry {
  id: number;
  [key: number]: any;
  texture?: Texture;
  width?: number;
  height?: number;
  label_id?: number;
}

export interface TextureMap {
  [id: number]: ProductEntry;
}

export type Color = string | null;
export type TextureId = number | null;
export type GridType = string | null;
export type FrameType = string | null;

export interface WallStyle {
  color: Color;
  textureId: TextureId;
}

export interface RoofStyle {
  color: Color;
  textureId: TextureId;
}

export interface TrimStyle {
  color: Color;
  textureId: TextureId;
}

export enum WindowParametricProperties {
  COLOR = 'color',
  GRID_TYPE = 'gridType',
  FRAME_TYPE = 'frameType',
}

export interface WindowStyle {
  [WindowParametricProperties.COLOR]: Color;
  [WindowParametricProperties.GRID_TYPE]: GridType;
  [WindowParametricProperties.FRAME_TYPE]: FrameType;
}

export interface LegacyDesignConfig {
  [FeatureCategories.ROOF]: RoofStyle;
  [FeatureCategories.TRIM]: TrimStyle;
  [FeatureCategories.WALL]: WallStyle;
  [FeatureCategories.WINDOW]: WindowStyle;
}

export interface TrackingDesignConfig {
  [FeatureCategories.ROOF]: {
    texture?: MenuItemType;
    color?: DesignStudioColor;
  };
  [FeatureCategories.TRIM]: {
    texture?: MenuItemType;
    color?: DesignStudioColor;
  };
  [FeatureCategories.WALL]: {
    texture?: MenuItemType;
    color?: DesignStudioColor;
  };
  [FeatureCategories.WINDOW]: {
    texture?: WindowItemType;
    color?: DesignStudioColor;
  };
}

export type TrackingMetadata = Pick<ButtonPressed, 'partner_id'>;
